/**
 * Same-origin base path for ALL Supabase Edge Function calls.
 *
 * Why this exists: the browser must never call the Edge Functions host directly.
 * That cross-origin request fails its CORS preflight at Cloudflare's HTTP/3 edge,
 * which blanks every data panel in the app (Overview, Paid Media Breakdown, etc.)
 * even though the backend is perfectly healthy. Instead, every Edge Function call
 * goes through this same-origin prefix, which a Vercel rewrite (see vercel.json)
 * proxies to the Supabase Edge Functions origin server-side. Same-origin requests
 * are never preflighted, so there is nothing for the edge to mishandle — and the
 * backend host is never exposed to the browser.
 *
 * SINGLE SOURCE OF TRUTH: import EDGE_FUNCTIONS_BASE everywhere an Edge Function URL
 * is built; never hardcode the backend host in client code. The guard test
 * tests/unit/no-cross-origin-edge-calls.test.ts fails the build if anything under
 * src/ reintroduces a direct cross-origin Edge Function URL.
 */
export const EDGE_FUNCTIONS_BASE = '/sb-fn';
